<ng-container *ngIf="tree.root.children.length">
  <app-tree-node-ext
    *ngFor="let node of tree.root.children"
    [node]="node"
    [nodeTemplate]="nodeDirective"
    [expandableNodeTemplate]="expandableNodeDirective">
  </app-tree-node-ext>
</ng-container>
